import { Injectable, signal, computed } from '@angular/core';
import { ConfirmationScreenDetail } from '@app/core/models/confirmation.model';

export interface PinputData {
  name: string;
  size: number;
  type: string;
  file?: any;
  preview?: string;
  captureResolution?: string;
  captureLayoutType?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmationStateService {
  // Private signal - only this service can modify
  private readonly _confirmationData = signal<ConfirmationScreenDetail | null>(null);
  private readonly _selectedDocuments = signal<string[]>([]);
  // private readonly _userSelection = signal<'have' | 'dontHave' | null>(null);

  // Public readonly signals - components can read
  readonly confirmationData = this._confirmationData.asReadonly();
  readonly selectedDocuments = this._selectedDocuments.asReadonly();
  // readonly userSelection = this._userSelection.asReadonly();

  // Computed signals
  readonly hasConfirmationData = computed(() => this._confirmationData() !== null);
  readonly hasSelectedDocuments = computed(() => this._selectedDocuments().length > 0);

  // pinput
  private readonly _pinputDocuments = signal<PinputData | null>(null);
  readonly pinputDocuments = this._pinputDocuments.asReadonly();
  readonly hasPinputDocuments = computed(() => this._selectedDocuments().length > 0);
  setPinputDocuments(pinputData: PinputData | null): void {
    this._pinputDocuments.set(pinputData);
  }

  /**
   * Set confirmation data
   */
  setConfirmationData(data: ConfirmationScreenDetail | null): void {
    this._confirmationData.set(data);
  }

  /**
   * Set selected documents
   */
  setSelectedDocuments(documents: string[]): void {
    this._selectedDocuments.set(documents);
  }

  /**
   * Set user selection
   */
  setUserSelection(selection: 'have' | 'dontHave' | null): void {
    // this._userSelection.set(selection);
  }

  /**
   * Update partial confirmation data
   */
  updateConfirmationData(partial: Partial<ConfirmationScreenDetail>): void {
    const current = this._confirmationData();
    if (current) {
      this._confirmationData.set({ ...current, ...partial });
    }
  }

  /**
   * Clear all state
   */
  clearState(): void {
    this._confirmationData.set(null);
    this._selectedDocuments.set([]);
    this._pinputDocuments.set(null);
    // this._userSelection.set(null);
  }

  /**
   * Reset to initial state
   */
  reset(): void {
    this.clearState();
  }
}